import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';

const PURPLE = '#00F1A7';

export default function Privacidade() {
  return (
    <>
      <PublicHeader />
      <Box sx={{ bgcolor: '#f8f9fa', minHeight: '70vh', py: { xs: 4, md: 6 } }}>
        <Container maxWidth="md">
          <Paper sx={{ p: { xs: 3, md: 5 }, borderRadius: 3 }}>
            <Typography variant="h4" sx={{ fontWeight: 800, mb: 1, color: PURPLE }}>
              Política de Privacidade e LGPD
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
              Última atualização: 20 de Junho de 2026
            </Typography>

            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mb: 2 }}>
              A SmyrnaCore Tecnologia (CNPJ 66.330.452/0001-40) (&ldquo;SmyrnaCore&rdquo;, &ldquo;nós&rdquo; ou &ldquo;nosso&rdquo;)
              está comprometida com a proteção da privacidade e dos dados pessoais de seus usuários. Esta Política de
              Privacidade descreve como coletamos, utilizamos, armazenamos e protegemos os dados pessoais tratados por meio
              da plataforma ConectaChurch (&ldquo;Plataforma&rdquo;), em conformidade com a Lei Geral de Proteção de Dados Pessoais
              (LGPD) — Lei 13.709/2018.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              1. Dados Coletados
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              Ao utilizar a Plataforma, os seguintes dados podem ser coletados:
            </Typography>

            <Typography variant="subtitle1" sx={{ fontWeight: 700, mt: 2, mb: 0.5 }}>
              1.1 Dados da Igreja (Controlador)
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li>Nome da igreja ou organização religiosa</li>
              <li>CNPJ (quando aplicável)</li>
              <li>Endereço da sede</li>
              <li>Nome, e-mail e telefone do responsável legal</li>
              <li>Dados de pagamento (processados via Stripe — não armazenamos dados de cartão)</li>
            </Box>

            <Typography variant="subtitle1" sx={{ fontWeight: 700, mt: 2, mb: 0.5 }}>
              1.2 Dados de Membros (Titulares)
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li>Nome completo</li>
              <li>E-mail</li>
              <li>Telefone</li>
              <li>Data de nascimento</li>
              <li>Endereço</li>
              <li>Dados de batismo e membresia</li>
              <li>Registros de frequência, consolidação, discipulado e participação em cursos e grupos</li>
              <li>Histórico financeiro de contribuições (quando o módulo financeiro for utilizado)</li>
            </Box>

            <Typography variant="subtitle1" sx={{ fontWeight: 700, mt: 2, mb: 0.5 }}>
              1.3 Dados de Navegação
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li>Endereço IP</li>
              <li>Tipo de navegador e sistema operacional</li>
              <li>Páginas acessadas e tempo de permanência</li>
              <li>Cookies essenciais para funcionamento da Plataforma</li>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              2. Finalidade do Tratamento
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              Todos os dados coletados são utilizados exclusivamente para as seguintes finalidades:
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li><strong>Gestão eclesiástica:</strong> controle de membros, secretaria, consolidação, discipulado, grupos de crescimento, jornada do membro, cursos e treinamentos</li>
              <li><strong>Gestão financeira:</strong> registro de contribuições e emissão de relatórios financeiros para a igreja</li>
              <li><strong>Comunicação:</strong> envio de notificações, lembretes e comunicados relevantes ao funcionamento da Plataforma</li>
              <li><strong>Suporte técnico:</strong> atendimento a solicitações e resolução de problemas</li>
              <li><strong>Melhoria da Plataforma:</strong> análise de uso para aprimoramento de funcionalidades (dados anonimizados)</li>
              <li><strong>Cobrança e faturamento:</strong> processamento de pagamentos de assinaturas via Stripe</li>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              3. Compartilhamento de Dados
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              A SmyrnaCore não comercializa, vende ou compartilha dados pessoais com terceiros, exceto nas seguintes
              situações estritamente necessárias:
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li><strong>Stripe:</strong> para processamento de pagamentos. O Stripe atua como operador de dados de pagamento e possui sua própria política de privacidade</li>
              <li><strong>Infraestrutura:</strong> provedores de hospedagem (VPS) para armazenamento dos dados</li>
              <li><strong>Obrigação legal:</strong> mediante ordem judicial ou requisição de autoridade competente, nos termos da lei</li>
              <li><strong>Consentimento do titular:</strong> mediante autorização expressa do titular dos dados</li>
            </Box>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              Todos os terceiros que possam ter acesso a dados pessoais são contratualmente obrigados a manter a
              confidencialidade e a segurança dos dados, em conformidade com a LGPD.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              4. Armazenamento e Segurança
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              Os dados são armazenados em servidores seguros com banco de dados PostgreSQL, protegidos por criptografia em
              trânsito (TLS/SSL) e em repouso. Adotamos medidas técnicas e organizacionais para proteger os dados contra
              acessos não autorizados, perda, destruição ou alteração, incluindo:
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li>Criptografia de senhas (SHA-256 com salt)</li>
              <li>Autenticação via token JWT</li>
              <li>Controle de acesso baseado em funções (RBAC)</li>
              <li>Firewall e monitoramento contínuo</li>
              <li>Backups periódicos automatizados</li>
              <li>Comunicação via HTTPS com TLS/SSL</li>
            </Box>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              Os dados são armazenados em servidores localizados em território nacional, em conformidade com o art. 3º da LGPD.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              5. Direitos do Titular
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              Nos termos da LGPD (Lei 13.709/2018), os titulares de dados pessoais têm os seguintes direitos:
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li><strong>Confirmação e acesso:</strong> confirmar a existência de tratamento e acessar seus dados</li>
              <li><strong>Correção:</strong> solicitar a correção de dados incompletos, inexatos ou desatualizados</li>
              <li><strong>Anonimização, bloqueio ou eliminação:</strong> solicitar a anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com a LGPD</li>
              <li><strong>Portabilidade:</strong> solicitar a portabilidade dos dados a outro fornecedor de serviço</li>
              <li><strong>Eliminação:</strong> solicitar a eliminação dos dados tratados com consentimento</li>
              <li><strong>Informação sobre compartilhamento:</strong> ser informado sobre as entidades públicas e privadas com as quais os dados foram compartilhados</li>
              <li><strong>Revogação de consentimento:</strong> revogar o consentimento a qualquer momento</li>
              <li><strong>Oposição:</strong> opor-se ao tratamento de dados quando não baseado em consentimento</li>
            </Box>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              Para exercer seus direitos, entre em contato com o Encarregado de Dados (DPO) pelo e-mail
              contato@smyrnacore.com.br. Responderemos sua solicitação no prazo máximo de 15 (quinze) dias.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              6. Cookies e Tracking
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              A Plataforma utiliza cookies essenciais para seu funcionamento, incluindo:
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li><strong>Cookies de autenticação:</strong> para manter o usuário logado durante a sessão (token JWT)</li>
              <li><strong>Cookies de preferências:</strong> para lembrar configurações do usuário</li>
            </Box>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              Não utilizamos cookies de rastreamento de terceiros para fins publicitários. O usuário pode configurar seu
              navegador para recusar cookies, mas isso pode afetar o funcionamento da Plataforma.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              7. Encarregado de Dados (DPO)
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              Nosso Encarregado de Proteção de Dados (Data Protection Officer) está disponível para esclarecimentos,
              solicitações e reclamações relacionadas ao tratamento de dados pessoais:
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li>E-mail: contato@smyrnacore.com.br</li>
              <li>WhatsApp: (81) 99600-1383</li>
              <li>Endereço: Recife, Pernambuco, Brasil</li>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              8. Base Legal
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              O tratamento de dados pessoais realizado pela SmyrnaCore fundamenta-se nas seguintes bases legais previstas
              na LGPD (Lei 13.709/2018):
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li><strong>Execução de contrato (Art. 7º, V):</strong> dados necessários para a prestação dos serviços contratados pela igreja</li>
              <li><strong>Consentimento (Art. 7º, I):</strong> dados de membros cujo consentimento foi obtido pela igreja controladora</li>
              <li><strong>Legítimo interesse (Art. 7º, IX):</strong> melhoria da Plataforma e análises estatísticas anonimizadas</li>
              <li><strong>Obrigação legal (Art. 7º, II):</strong> emissão de documentos fiscais e cumprimento de obrigações legais</li>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              9. Retenção de Dados
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              Os dados pessoais são mantidos apenas pelo tempo necessário para cumprir as finalidades descritas nesta política,
              observando os prazos legais aplicáveis. Após o cancelamento da conta, os dados serão mantidos por até 90 (noventa)
              dias para fins de backup e posteriormente eliminados de forma segura, salvo obrigação legal de retenção.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              A igreja controladora é responsável pela retenção e exclusão dos dados de seus membros, podendo excluí-los a
              qualquer momento diretamente pela Plataforma, em conformidade com a LGPD e seu próprio aviso de privacidade.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              10. Disposições Finais
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              Esta Política de Privacidade pode ser alterada a qualquer momento, mediante aviso prévio na Plataforma ou por
              e-mail. Recomendamos a leitura periódica desta política. O uso continuado da Plataforma após alterações implica
              na aceitação dos novos termos.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              Em caso de incidente de segurança que possa acarretar risco relevante aos titulares, a SmyrnaCore se compromete
              a comunicar os titulares afetados e a Autoridade Nacional de Proteção de Dados (ANPD) nos termos do art. 48 da LGPD.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              Esta política aplica-se exclusivamente à Plataforma ConectaChurch. Ao utilizar links externos ou serviços de terceiros,
              recomendamos consultar as respectivas políticas de privacidade.
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 4, textAlign: 'center' }}>
              SmyrnaCore Tecnologia LTDA — CNPJ 66.330.452/0001-40 | LGPD — Lei 13.709/2018
            </Typography>
          </Paper>
        </Container>
      </Box>
      <Footer />
    </>
  );
}
